import { RouteConfig } from 'vue-router';

const Home = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "Home" */ '@/views/Home');

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home,
    meta: {
      eventName: 'landing',
      eventNameAr: 'صفحة الهبوط',
      eventNameEn: 'landing',
    },
  },
] as RouteConfig[];

export default routes;
